import React from 'react';
import { Image } from 'react-bootstrap';
import { CustomTitleLabel } from 'components/earning/CustomBaseComponments';

import './DisplayItems.scss';

export const titleForItem = (title, moreStyle) => {
  return <CustomTitleLabel title={title} className={moreStyle} />
};

export const listItem = (title, value, moreStyle) => {
  return (
    <>
      {titleForItem(title, moreStyle)}
      <label className="banners-detail-text">{value || '-'}</label>
    </>
  );
};

export const listMultiItem = (title, values, moreStyle) => {
  let items = <label className="banners-detail-text">{'-'}</label>;
  if (Array.isArray(values) && values.length) {
    items = <>
      {values.map((value) => (
        <li className="banners-detail-text" style={{display: "list-item"}}>{value || '-'}</li>
      ))}
    </>
  }
  return (
    <>
      {titleForItem(title, moreStyle)}
      {items}
    </>
  );
};

export const listImage = (title, src) => {
  if (!src) {
    return (
      <>
        {listItem(title, '-')}
      </>
    )
  }
  return (
    <>
      {titleForItem(title)}
      <Image className="feature-campaign-detail-image" src={src} />
    </>
  );
};
